import projectUtils from "../../../../../../utils/project-utils.js";
import ScheduleAttendanceInfoService from "../../../../../../services/reports/schedule-attendance-info-service.js";

const CellLink = ({value, onClick}) => {
    if (!value) return "";

    return (
        <button
            type="button"
            className="text-[#1588F3] underline cursor-pointer print:text-inherit print:!no-underline"
            onClick={onClick}
        >
            {value}
        </button>
    );
};

export default function AttendancesTable({title, data}) {
    const attendances = data?.schedule?.attendance_list ?? [];
    const boName = data?.schedule?.boName ?? "";

    return (
        <div className="space-y-4 px-5">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                {title}
            </h2>

            <div className="overflow-hidden rounded-lg border border-[#D2D3D5] font-[Roboto,sans-serif] text-[#2E3742]">
                <div className="grid grid-cols-12 gap-2 items-center bg-[#efefef] px-2 h-10 text-sm font-bold border-b border-[#D2D3D5]">
                    <span className="col-span-2">Protocolo</span>
                    <span className="col-span-2">Início</span>
                    <span className="col-span-2">Fim</span>
                    <span className="col-span-2">Despacho</span>
                    <span className="col-span-2">{boName}</span>
                    <span className="col-span-2">Guarnição</span>
                </div>

                {!attendances.length &&
                    <div className="px-2 h-7.5 text-center text-sm content-center">Nenhum registro.</div>
                }

                {attendances.map((attendance, index) => (
                    <div
                        key={attendance.attendance_protocol ?? index}
                        className={`
                            grid grid-cols-12 gap-2 items-center px-2 py-1 text-sm hover:bg-[#eef3fb]
                            print:break-inside-avoid
                            ${index === attendances.length - 1 ? "" : "border-b border-[#D2D3D5]"}
                        `}
                    >
                        <span className="col-span-2">{attendance.attendance_protocol ?? ""}</span>
                        <span className="col-span-2">{projectUtils.formatDate(attendance.attendance_start) ?? ""}</span>
                        <span className="col-span-2">{projectUtils.formatDate(attendance.attendance_end) ?? ""}</span>
                        <span className="col-span-2">
                            <CellLink
                                value={attendance.dispatch_numbercheckbook}
                                onClick={() => window.open(ScheduleAttendanceInfoService.getDispatch(attendance.dispatch_id), "_blank")}
                            />
                        </span>
                        <span className="col-span-2">
                            <CellLink
                                value={attendance.dispatch_occurrencenumber}
                                onClick={() => window.open(ScheduleAttendanceInfoService.getOccurrence(attendance.dispatch_occurrencenumber), "_blank")}
                            />
                        </span>
                        <span className="col-span-2">{attendance.garrison_name ?? ""}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}
